
enum EpType {
    bookingsuedtirol = 'bookingsuedtirol',
    kognitiv = 'kognitiv'
}
export default EpType